import "./ProgressBar.css";

export function ProgressBar(props: { ratio: number }): React.JSX.Element {
  const percent = Math.round(Math.min(1, Math.max(0, props.ratio)) * 100);
  return (
    <div className="progress-bar" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
      <div className="progress-bar__fill" style={{ width: `${percent}%` }} />
    </div>
  );
}
